import { Component, OnInit } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-pending-changes-dialog',
  templateUrl: './pending-changes-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogContent,
    MatIcon,
    MatDialogActions,
    TranslateModule,
    MatButton,
    MatDialogClose
  ],
  styleUrls: ['./pending-changes-dialog.component.scss']
})
export class PendingChangesDialogComponent implements OnInit {

    constructor(
        public dialog: MatDialogRef<PendingChangesDialogComponent>,
    ) { }

    public ngOnInit() {
    }

    public onConfirmClicked(result: number): void {
        this.dialog.close(result);
    }

}
